'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:PaymentCtrl
 * @description
 * # PaymentCtrl
 * Controller of the ribytRsvpApp
 */
angular.module('ribytRsvpApp')
    .controller('PaymentCtrl', function () {
        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = false;
        /**
         * Set controller vars
         */
        $rootScope.showTabs = true;
    });
